import { Entry } from '../Entry'

export function Entry20261007() {
  return (
    <Entry title="2026 Oct 7 - v3.11.21">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/27229/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
